import { AVAILABLE_STATE } from "constants/driveEntryState";
import type { OrchidDriveFile } from "contexts/orchid-drive/types";

export function isDriveFileNotifyAvailable(entry: OrchidDriveFileNotify) {
  return !entry.deleted_datetime && entry.file_status === AVAILABLE_STATE;
}

export function isDriveFileAvailable(entry: OrchidDriveFile) {
  return !entry.deletedDatetime && entry.fileStatus === AVAILABLE_STATE;
}
